var _path, _path2, _circle, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24H12L11.9957 19.2064L24 0H0L0 24Z",
    fill: "#9DCC3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24.0007H9.03772L4.54047 16.7319L12.2985 5.20898L24 24.0007Z",
    fill: "#67B340"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6243,
    cy: 11.9993,
    r: 7.70833,
    fill: "#67B340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0084 4.67037C13.5628 4.85048 14.0827 5.08744 14.564 5.37271L14.5647 6.6712L13.4811 7.3205C13.1237 7.10295 12.7356 6.92316 12.3203 6.78823C9.44113 5.85273 6.34873 7.42839 5.41323 10.3076C4.47773 13.1867 6.05339 16.2791 8.93256 17.2146C11.8117 18.1501 14.9041 16.5745 15.8396 13.6953C16.516 11.6138 15.8798 9.42082 14.3874 8.012L15.6641 6.16435C17.9413 8.13139 18.9457 11.342 17.9575 14.3834C16.6419 18.4323 12.2933 20.648 8.24442 19.3325C4.19559 18.0169 1.97982 13.6683 3.29537 9.61942C4.61092 5.57059 8.9596 3.35482 13.0084 4.67037Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70898 8.44141V15.5581H9.66327V13.3785H10.6163L11.8685 15.5414C11.8685 15.5414 13.9455 15.5746 13.9266 15.5414L12.4918 13.0185C12.4918 13.0185 13.7261 12.4528 13.7261 10.91C13.7261 9.52141 12.6461 8.44141 11.1033 8.44141H7.70898ZM11.0003 10.19C11.4632 10.19 11.7718 10.4986 11.7718 10.91C11.7718 11.3214 11.4632 11.63 11.0003 11.63H9.66318V10.19H11.0003Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKre);
export default __webpack_public_path__ + "static/media/kre.a627934a.svg";
export { ForwardRef as ReactComponent };